import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useOrg } from '../context/OrgContext';

/**
 * OrgGuard — intercepts navigation for org users on consumer routes.
 * 
 * If the logged-in user is an org member and they're on a consumer URL
 * (e.g. /dashboard, /channels/5), this component redirects them to the
 * org-scoped version (e.g. /org/belong/dashboard, /org/belong/channels/5).
 * 
 * Consumer (non-org) users pass through unaffected.
 */
function OrgGuard({ children }) {
  const { isOrgUser, orgSlug, orgLoading } = useOrg();
  const location = useLocation();

  if (orgLoading) {
    return <div style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><p>Loading...</p></div>;
  }

  // Not an org user — let them through to the consumer page
  if (!isOrgUser || !orgSlug) {
    return children;
  }

  // Org user on a consumer URL — redirect to org-scoped version
  const currentPath = location.pathname;
  const orgPrefix = `/org/${orgSlug}`;

  // Build the org-scoped URL from the current consumer path
  const orgPath = `${orgPrefix}${currentPath}`;
  return <Navigate to={orgPath + location.search} replace />;
}

export default OrgGuard;
